import { Routes } from 'types/enums';

export default function getSocialAuthCallbackUrl(social: string): string {
  return 'callbackURL=' + process.env.HOST_ROOT + Routes.AuthSocial + `/${social}/`;
}
